/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import React, { useContext, useState } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import DropDwonSVG from '../icons/profiledropdown.svg';
import LogoutIconSVG from '../icons/logoutIcon.svg';
import ProfileIconSVG from '../icons/profileIcon.svg';
import { HeaderContext } from '../../../contexts/headerContext';
import { useUser } from '../../../contexts/ssr-user-context';

function TopRightUserInfo() {
  const menuItems = [
    { label: 'Profile', icon: ProfileIconSVG, url: '/user/profile' },
    { label: 'Logout', icon: LogoutIconSVG, url: '/user/logout' },
  ];
  const [isOpen, setIsOpen] = useState(false);
  // const [profileImageUrl, setProfileImageUrl] = useState(false);
  const router = useRouter();
  const { setShowProfilePopup, setShowLogoutPopup } = useContext(HeaderContext);
  const { user } = useUser();
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleShowProfile = () => {
    setIsOpen(!isOpen);
    setShowProfilePopup(true);
  };
  const redirectPage = (url, label) => {
    setIsOpen(!isOpen);
    if (label === 'Logout') {
      setShowLogoutPopup(true);
    } else {
      router.push(url);
    }
  };
  // useEffect(() => {
  //   // debugger;
  //   if (user?.profile.accountDetails?.photo) {
  //     fetchImage(user.profile.accountDetails.photo).then((imgDataUrl) => {
  //       setProfileImageUrl(imgDataUrl);
  //       setProfileImage(imgDataUrl);
  //     });
  //   }
  // }, [user]);

  return (
    <div className="w-full lg:w-auto">
      <div className="relative flex items-center justify-between space-x-4">
        {/* <div className="lg:hidden w-[80%] sm:w-[60%] lg:w-[50%] text-center font-bold text-lg text-white">
          <img src={logo} alt="Made Easy Logo" className="w-[128px] h-6 lg:w-[175px] lg:h-8" />
        </div> */}
        {/* <div className="w-[10%] sm:w-[100%] flex items-center justify-end">
          <Notification />
        </div> */}
        {/* Profile Section */}
        <div className="hidden sm:flex space-x-4 cursor-default">
          {/* <UserCircleIcon width={40} height={40} className="w-10 h-10 p-1 rounded-full ring-2 ring-gray-300 dark:ring-gray-500" /> */}
          {user?.profile?.accountDetails?.profilePicture
            ? (
              <Image
                width={50}
                height={50}
                src={user?.profile.accountDetails?.profilePicture} // Replace with profile image URL
                alt="Profile"
                className="w-10 h-10 p-1 rounded-full ring-2 ring-gray-300 dark:ring-gray-500"
              />
            ) : <UserCircleIcon width={40} height={40} className="w-10 h-10 p-1 rounded-full ring-2 ring-gray-300 dark:ring-gray-500" />}
          <div>
            <button
              className="flex items-center space-x-2 text-sm font-medium text-gray-800 focus:outline-none"
              onClick={toggleDropdown}
            >
              <span>{user?.name}</span>
              <Image width={12} height={8} src={DropDwonSVG} alt="profile dorpdwon" />
            </button>
            <p className="text-sm text-gray-500">{user?.email || user?.profile?.accountDetails?.email}</p>
          </div>

          {/* Dropdown Menu */}
          {isOpen && (
            <div className="absolute right-0 top-12 mt-2 w-[240px] border-b-[4px] border-b-[#00C3FF] bg-white border border-blueThinDobule shadow-lg rounded-lg py-2 z-[999]">
              { menuItems.map((item) => (
                <div
                  onClick={item.label === 'Profile' ? handleShowProfile : () => redirectPage(item.url, item.label)}
                  className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                >
                  <span>
                    {' '}
                    <Image width={20} height={20} src={item.icon} alt={item.label} />
                  </span>
                  {' '}
                  {item.label}
                </div>
              )) }

            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TopRightUserInfo;
